import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { AccessTokenModalType } from '../../../../common/constants/access-token';
import type { SupportedThirdParty } from '../../../../common/constants/import-type';
import { INITIAL_UI_STATE } from '../../../../common/constants/state';
import type { AccessTokenModalState, UIState } from '../../../../common/types';

export const setAccessTokenModalState =
	(accessTokenModal: Partial<AccessTokenModalState>) =>
	({ setState, getState }: StoreActionApi<UIState>) => {
		setState({ accessTokenModal: { ...getState().accessTokenModal, ...accessTokenModal } });
	};

export const resetAccessTokenModalState =
	() =>
	({ setState }: StoreActionApi<UIState>) => {
		setState({ accessTokenModal: INITIAL_UI_STATE.accessTokenModal });
	};

export const setRequestAuthenticationToken =
	(props: {
		thirdParty: SupportedThirdParty;
		modalType: AccessTokenModalType;
		shouldCloseAndReturnToUploadStep?: boolean;
	}) =>
	({ setState, getState }: StoreActionApi<UIState>) => {
		let resolve = (value: boolean) => value;
		const promise = new Promise((resolveProp: (value: boolean) => void) => {
			resolve = (value) => {
				resolveProp(value);
				return value;
			};
		});
		setState({
			accessTokenModal: {
				...getState().accessTokenModal,
				isModalOpen: true,
				onFinishAccessTokenValidation: resolve,
				...props,
			},
		});
		return promise;
	};
